// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
#root {
    background-color: var(--main-very-light-hg-color) !important;
}

.filterPanel {
    margin: 10px;
    font-size: 12px;
}

input[type="date"] {
    padding: 0.3em !important;
    width: 100%;
    max-width: 18em;
    color: gray;
}
label {
    color: gray;
}

.flex-row {
    flex-direction: row !important;
}

.selectDropdownContainer {
    margin-right: 5px;
    color: gray;
}

.MuiButtonBase-root {
    font-size: 9px !important;
}

.exportButton {
    width: 200px !important;
}

.moreFilterButton {
    width: 200px !important;
    color : var(--main-hg-color) !important;
    background-color : var(--main-very-light-hg-color) !important;
}

#start, #end {
    height: 35px;
    margin-left: 15px;
}

.filtersSelection {
    padding: 20px 20px 20px 60px;
}

.modal-header {
    background-color: var(--main-hg-color);
    color: white !important;
}

.selectDate {
    height: 35px;
    background-color: white;
    color: gray;
    padding:0 0 0 10px !important;
}

.cardBodyFieldSelection {
    width: 100%;
}

.cardBodyFieldSelection .MuiGrid-container  {
    width: 100%;
}

.cardBodyFieldSelection .MuiGrid-item {
    width: 100%;
}

.cardBodyFieldSelection .MuiAutocomplete-root  {
    width: 100%;
}


@media only screen and (max-width: 768px) {
    .exportButtonContainer {
        display: none !important;
    }
    .exportButton, .moreFilterButton {
        display: none !important;
        /* margin-top: 10px !important;
        height: 100px !important;
        margin-right: 0px !important; */
    }

    .selectDate {
        text-align: center;
    }
    #start, #end {
        margin : 0;
    }
    .dropdownSelection {
        display: none !important;
    }
    .backOfficeButton {
        display: none !important;
    }
    input[type="date"] {
        width: 100% !important;
    }
    .validate {
        margin-top: 15px !important;
    }
}

.btnResetDates {
    background: #f8b584 !important;
    height: 18px !important;
    font-size: 12px !important;
    padding: 0px !important;
}


.btnResetDates:hover {
    background: var(--highlight-bg-color) !important;
    font-size: 14px !important;
}`, "",{"version":3,"sources":["webpack://./src/styles/filterpanel.css"],"names":[],"mappings":";AACA;IACI,4DAA4D;AAChE;;AAEA;IACI,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,eAAe;IACf,WAAW;AACf;AACA;IACI,WAAW;AACf;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;IACvB,uCAAuC;IACvC,6DAA6D;AACjE;;AAEA;IACI,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,sCAAsC;IACtC,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,uBAAuB;IACvB,WAAW;IACX,6BAA6B;AACjC;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;;AAGA;IACI;QACI,wBAAwB;IAC5B;IACA;QACI,wBAAwB;QACxB;;uCAE+B;IACnC;;IAEA;QACI,kBAAkB;IACtB;IACA;QACI,UAAU;IACd;IACA;QACI,wBAAwB;IAC5B;IACA;QACI,wBAAwB;IAC5B;IACA;QACI,sBAAsB;IAC1B;IACA;QACI,2BAA2B;IAC/B;AACJ;;AAEA;IACI,8BAA8B;IAC9B,uBAAuB;IACvB,0BAA0B;IAC1B,uBAAuB;AAC3B;;;AAGA;IACI,gDAAgD;IAChD,0BAA0B;AAC9B","sourcesContent":["\n#root {\n    background-color: var(--main-very-light-hg-color) !important;\n}\n\n.filterPanel {\n    margin: 10px;\n    font-size: 12px;\n}\n\ninput[type=\"date\"] {\n    padding: 0.3em !important;\n    width: 100%;\n    max-width: 18em;\n    color: gray;\n}\nlabel {\n    color: gray;\n}\n\n.flex-row {\n    flex-direction: row !important;\n}\n\n.selectDropdownContainer {\n    margin-right: 5px;\n    color: gray;\n}\n\n.MuiButtonBase-root {\n    font-size: 9px !important;\n}\n\n.exportButton {\n    width: 200px !important;\n}\n\n.moreFilterButton {\n    width: 200px !important;\n    color : var(--main-hg-color) !important;\n    background-color : var(--main-very-light-hg-color) !important;\n}\n\n#start, #end {\n    height: 35px;\n    margin-left: 15px;\n}\n\n.filtersSelection {\n    padding: 20px 20px 20px 60px;\n}\n\n.modal-header {\n    background-color: var(--main-hg-color);\n    color: white !important;\n}\n\n.selectDate {\n    height: 35px;\n    background-color: white;\n    color: gray;\n    padding:0 0 0 10px !important;\n}\n\n.cardBodyFieldSelection {\n    width: 100%;\n}\n\n.cardBodyFieldSelection .MuiGrid-container  {\n    width: 100%;\n}\n\n.cardBodyFieldSelection .MuiGrid-item {\n    width: 100%;\n}\n\n.cardBodyFieldSelection .MuiAutocomplete-root  {\n    width: 100%;\n}\n\n\n@media only screen and (max-width: 768px) {\n    .exportButtonContainer {\n        display: none !important;\n    }\n    .exportButton, .moreFilterButton {\n        display: none !important;\n        /* margin-top: 10px !important;\n        height: 100px !important;\n        margin-right: 0px !important; */\n    }\n\n    .selectDate {\n        text-align: center;\n    }\n    #start, #end {\n        margin : 0;\n    }\n    .dropdownSelection {\n        display: none !important;\n    }\n    .backOfficeButton {\n        display: none !important;\n    }\n    input[type=\"date\"] {\n        width: 100% !important;\n    }\n    .validate {\n        margin-top: 15px !important;\n    }\n}\n\n.btnResetDates {\n    background: #f8b584 !important;\n    height: 18px !important;\n    font-size: 12px !important;\n    padding: 0px !important;\n}\n\n\n.btnResetDates:hover {\n    background: var(--highlight-bg-color) !important;\n    font-size: 14px !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
